<template lang="pug">
#app
  navigation
  .main
    router-view
  dialog-selector
  dialog-message
</template>

<script>
import "@/assets/style/main.scss";
import Navigation from "@/components/common/Navigation";
import DialogMessage from "@/components/common/DialogMessage";
import DialogSelector from "@/components/common/DialogSelector";

export default {
  name: "App",
  components: {
    navigation: Navigation,
    "dialog-message": DialogMessage,
    "dialog-selector": DialogSelector,
  },
};
</script>

<style lang="scss"></style>
